import { createPageEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import { polarisProductFinancialYearSettingsEntryPoint } from '@atlassian/jira-spa-apps-polaris-settings-dates/entrypoint.tsx';

export const polarisProductFinancialYearSettingsPageEntryPoint = createPageEntryPoint({
	main: polarisProductFinancialYearSettingsEntryPoint,
	topNavigationMenuId: MENU_ID.SETTINGS,
});
